import { TemplateEditViews } from '../common/types';
import { useQueryParamContext } from '../context/QueryParamContext';
import { SMSContext } from './context/SMSContext';
import PreviewWithData from './PreviewWithData';
import Settings from './Settings';

const renderView = (view: string) => {
  switch (view) {
    case TemplateEditViews.preview:
      return <PreviewWithData />;
    default:
      return <Settings />;
  }
};

export const EditSMS = () => {
  const { view } = useQueryParamContext();

  return <SMSContext>{renderView(view)}</SMSContext>;
};

export default EditSMS;
